import lifecycleMethods from './lifecycle-methods';
import tabs from './tabs';

export default {
    vjs: {
        ...lifecycleMethods,
        ...tabs
    }
};
